import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export type AllowedIcons =
  "trash-can";

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.css']
})
export class ListItemComponent implements OnInit {

  @Input() url: string | undefined = undefined;
  @Output('click') onClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() icon: AllowedIcons | null;
  @Output() iconClick = new EventEmitter();
  isIconClickable = false;

  constructor() {}

  ngOnInit() {
    this.isIconClickable = this.iconClick.observers.length !== 0;
  }

  handleClick() {
    this.onClick.emit(true);
  }

}
